import * as ExperiencesClient from '../clients/experiences';
import { constants } from '../stores/ExperienceStore';
import SuggestionsClient from '../clients/suggestions';

export default {
  experiences: {
    fetchPopularExperiences(lang) {
      ExperiencesClient.fetchPopularExperiences(lang)
        .then(result =>
          this.dispatch(constants.FETCH_POPULAR_EXPERIENCES_SUCCESS, result.relations.filter(relation => relation._type === 'experience'))
        );

    },
    fetchExperience(experienceId, lang, addLiveParam = false) {
      this.dispatch(constants.FETCH_EXPERIENCE, { experienceId, lang });

      ExperiencesClient.fetchExperience(experienceId, lang, addLiveParam)
        .then((experience) => {
          this.dispatch(constants.FETCH_EXPERIENCE_SUCCESS, { experience, lang });
        })
        .catch((error) => {
          console.log('fetchExperience', error);
          if (error.status === 410) {
            const response = JSON.parse(error.responseText);
            this.dispatch(constants.FETCH_EXPERIENCE_REDIRECT, { lang, id: experienceId, ...response });
          } else if (error.status === 404) {
            this.dispatch(constants.FETCH_EXPERIENCE_NOT_FOUND, { lang, id: experienceId });
          } else {
            throw error;
          }
        });
    },
    fetchAvailableTimes(experienceId, date) {
      this.dispatch(constants.FETCH_AVAILABLE_TIMES, { experienceId, date });
      ExperiencesClient.fetchAvailableTimes(experienceId, date)
        .then(availableTimes => this.dispatch(constants.FETCH_AVAILABLE_TIMES_SUCCESS, { experienceId, date, availableTimes }));
    },
    fetchAvailableDatesPerHost(experienceId) {
      this.dispatch(constants.FETCH_AVAILABLE_DATES_PER_HOST, { experienceId });
      ExperiencesClient.fetchAvailableDatesPerHost(experienceId)
        .then(availableDates => this.dispatch(constants.FETCH_AVAILABLE_DATES_PER_HOST_SUCCESS, { experienceId, availableDates }));
    },
    fetchSuggestions(experienceId, lang, isOriginals = null) {
      this.dispatch(constants.FETCH_SUGGESTIONS, { experienceId });
      let suggestionsEndpoint;
      if (isOriginals === true) {
        suggestionsEndpoint = SuggestionsClient.getByIdInSameCategory;
      } else if (isOriginals === false) {
        suggestionsEndpoint = SuggestionsClient.getByIdBySameHostOrInSameCategory;
      } else {
        suggestionsEndpoint = SuggestionsClient.getById;
      }
      suggestionsEndpoint(experienceId, lang)
        .then(response =>
          this.dispatch(constants.FETCH_SUGGESTIONS_SUCCESS, { experienceId, response })
        ).catch((e) => {
          console.error(e);
          this.dispatch(constants.FETCH_SUGGESTIONS_FAIL, { experienceId });
        });
    },
  },
};
